
export enum PaymentProvider {
  InTime = 'in-time',
  Barion = 'barion',
  Stripe = 'stripe',
  BtPay = 'btepos',
}
